import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/packagesSalesSaga";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

const OnlyChallengers = () => {
  const dispatch = useDispatch();
  const onlyChallengers = useSelector(
    (state) => state.packagesSales.selectedFilters.only_challengers
  );

  return (
    <ToggleableButton
      isActive={onlyChallengers}
      isRadio
      title="only-challengers"
      onClick={(data) => dispatch(actionCreators.updateOnlyChallengers(data))}
    />
  );
};

export default OnlyChallengers;
